import React, { FC, useEffect, useState } from 'react'

import { RequiredFieldsCardItem } from '../RequiredFieldsCardItem/RequiredFieldsCardItem'

import { getHorseRequiredFields } from '../../../../../../helpers/requiredFields'
import { useProfile } from '../../../../../../hooks/useProfile'

import { IProfileReqField } from '../../../../../../pages/competitor/clinicAndOther/Tabs/components/ProfileFields'
import { IHorseData } from '../../../../../../models/horse/horse.interface'
import { IHorseCompetitorDocument } from '../../../../../../models/horse-competiton-paperwork/horse-competiton-paperwork-interface'
import { IHorsesWithPaperwork } from '../../tabs/HorsesTab/HorsesTab'

interface HorseRequiredFieldsCardProps {
  index: number
  horse: IHorseData
  paperwork: IHorseCompetitorDocument | null
  eventRequiredHorseFields?: string[]
  horsesWithPaperwork: IHorsesWithPaperwork[]
  setHorsesWithPaperwork: (state: IHorsesWithPaperwork[]) => void
  isEditable?: boolean
}

export const HorseRequiredFieldsCard: FC<HorseRequiredFieldsCardProps> = ({
  index,
  horse,
  paperwork,
  eventRequiredHorseFields,
  horsesWithPaperwork,
  setHorsesWithPaperwork,
  isEditable,
}) => {
  const { onSaveEditHorse, onCancelEditHorse, onChangeHorseInput } = useProfile()

  const [requiredFields, setRequiredFields] = useState<IProfileReqField[]>([])
  const [isEdit, setIsEdit] = useState(false)

  useEffect(() => {
    const fields = getHorseRequiredFields({ horse, paperwork, eventRequiredHorseFields })
    setRequiredFields(fields)
  }, [eventRequiredHorseFields, horse, paperwork])

  return (
    <RequiredFieldsCardItem
      requiredFields={requiredFields}
      onCancelEdit={() =>
        onCancelEditHorse({ index, horsesWithPaperwork, setHorsesWithPaperwork, setIsEdit })
      }
      onSaveEdit={() => onSaveEditHorse({ index, horsesWithPaperwork, setIsEdit })}
      onChange={({ fieldName, fieldType, fieldKey, option }) =>
        onChangeHorseInput({
          fieldName,
          fieldType,
          fieldKey,
          option,
          index,
          horsesWithPaperwork,
          setHorsesWithPaperwork,
        })
      }
      isEditable={isEditable}
      setIsEdit={setIsEdit}
      isEdit={isEdit}
    />
  )
}
